export const openPageList = [
    '/home',
    '/linkInvalid',
    '/goodsSearchPage',
    '/channel/goodsDetailNew/',
    '/channel/open/goodsDetailNew/'
]
export const BANNER_TYPE_NONE_KEY = 'none' // BANNER 无连接
export const BANNER_TYPE_OUTSIDE_KEY = 'outside' // BANNER 跳转外部链接
export const BANNER_TYPE_INSIDE_KEY = 'inside' // BANNER 跳转品牌站分类
export const BANNER_TYPE_GOOD_DETAIL_KEY = 'goodDetail' // BANNER 跳转品牌站单款商品

export const SESSION_KEY_REFERRER_IS_SUPPLIER = 'referrer_is_supplier'
export const SESSION_KEY_REFERRER_IS_FINDCOOPERATIVE = 'referrer_is_findCooperative'
export const LOCATION_KEY_DLZ_INVITEDID = '_dlz_invitedId'

export const LOCATION_KEY_PARTNER_INVITEDID = '_dlz_partner_invitedId' // 合伙人推广商家
